import { __awaiter, __generator } from "tslib";
import { getMsalClient } from './client';
export var signOut = function (account) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getMsalClient()
                    .logoutRedirect({ account: account })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
